import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/prelogin/home/home.component';
import { LoginComponent } from './components/prelogin/login/login.component';
import { ForgotpasswordComponent } from './components/prelogin/forgotpassword/forgotpassword.component';
import { InsuranceloginComponent } from './components/prelogin/insurancelogin/insurancelogin.component';
import { BikeshopWizardComponent } from './components/prelogin/bikeshop-wizard/bikeshop-wizard.component';
import { CallbackXeroComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/callback-xero/callback-xero.component';
import { CallbackLightspeedComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/callback-lightspeed/callback-lightspeed.component';
import { CallbackVendComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/callback-vend/callback-vend.component';
import { CallbackShopifyComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/callback-shopify/callback-shopify.component';
import { CallbackSquareComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-square/callback-square/callback-square.component';
import { HeartlandsCallbackComponent } from './components/prelogin/bikeshop-wizard/wizard-link-pos/link-heartlands/heartlands-callback/heartlands-callback.component';
import { TFACodeComponent } from './components/prelogin/tfacode/tfacode.component';
import { TFASetupComponent } from './components/prelogin/tfasetup/tfasetup.component';
import { StripeConnectCallbackComponent } from './components/portal/bikeshop/in-app-payment-configuration/connect-stripe/stripe-connect-callback/stripe-connect-callback.component';
import { PortalComponent } from './components/portal/bikeshop/portal.component';
import { QuickLaunchComponent } from './components/portal/bikeshop/quick-launch/quick-launch.component';
import { DashboardComponent } from './components/portal/bikeshop/dashboard/dashboard.component';
import { RecordPaymentDetailsComponent } from './components/portal/bikeshop/record-payment-details/record-payment-details.component';
import { ManageSubscriptionsComponent } from './components/portal/bikeshop/manage-subscriptions/manage-subscriptions.component';
import { DueForServiceDetailComponent } from './components/portal/bikeshop/dashboard/due-for-service-detail/due-for-service-detail.component';
import { MyprofileComponent } from './components/portal/bikeshop/myprofile/myprofile.component';
import { TFAProfileSetupComponent } from './components/portal/bikeshop/myprofile/tfaprofile-setup/tfaprofile-setup.component';
import { CalendarComponent } from './components/portal/bikeshop/calendar/calendar.component';
import { ReportsComponent } from './components/portal/bikeshop/reports/reports.component';
import { ServicesComponent } from './components/portal/bikeshop/services/services.component';
import { MessageTypesComponent } from './components/portal/bikeshop/message-types/message-types.component';
import { PurchaseMessagingBundleComponent } from './components/portal/bikeshop/purchase-messaging-bundle/purchase-messaging-bundle.component';
import { PosProductsComponent } from './components/portal/bikeshop/pos-products/pos-products.component';
import { ImportProductsComponent } from './components/portal/bikeshop/pos-products/import-products/import-products.component';
import { ServiceTypesComponent } from './components/portal/bikeshop/service-types/service-types.component';
import { ImportServiceTypesComponent } from './components/portal/bikeshop/service-types/import-service-types/import-service-types.component';
import { ChecklistItemsComponent } from './components/portal/bikeshop/checklist-items/checklist-items.component';
import { ChecklistConfigurationComponent } from './components/portal/bikeshop/checklist-configuration/checklist-configuration.component';
import { ShopProfileComponent } from './components/portal/bikeshop/shop-profile/shop-profile.component';
import { SettingsComponent } from './components/portal/bikeshop/settings/settings.component';
import { PosIntegrationsComponent } from './components/portal/bikeshop/pos-integrations/pos-integrations.component';
import { CollectionsSetupV2Component } from './components/portal/bikeshop/collections-setup-v2/collections-setup-v2.component';
import { CyclistsComponent } from './components/portal/bikeshop/cyclists/cyclists.component';
import { ImportCyclistsComponent } from './components/portal/bikeshop/cyclists/import-cyclists/import-cyclists.component';
import { UsersV2Component } from './components/portal/bikeshop/users-v2/users-v2.component';
import { UsersComponent } from './components/portal/bikeshop/users/users.component';
import { ThirdPartyComponent } from './components/portal/bikeshop/third-party/third-party.component';
import { SpecialOrdersComponent } from './components/portal/bikeshop/special-orders/special-orders.component';
import { CollectionsComponent } from './components/portal/bikeshop/collections/collections.component';
import { CommunityComponent } from './components/portal/bikeshop/community/community.component';
import { CommunicationComponent } from './components/portal/bikeshop/community/communication/communication.component';
import { InAppPaymentConfigurationComponent } from './components/portal/bikeshop/in-app-payment-configuration/in-app-payment-configuration.component';
import { InsuranceQuoteCreationComponent } from './components/portal/bikeshop/insurance/insurance.component';
import { SwitchShopComponent } from './components/portal/bikeshop/switch-shop/switch-shop.component';
import { OtherSettingsComponent } from './components/portal/bikeshop/other-settings/other-settings.component';
import { OnlineWidgetComponent } from './components/portal/bikeshop/online-widget/online-widget.component';
import { CouponsComponent } from './components/portal/bikeshop/coupons/coupons.component';
import { CouponDetailComponent } from './components/portal/bikeshop/coupons/coupon-detail/coupon-detail.component';
import { JobCardMessagesComponent } from './components/portal/bikeshop/job-card-messages/job-card-messages.component';
import { ExternalRedirectComponent } from './components/portal/bikeshop/external-redirect/external-redirect.component';
import { BikeSalesComponent } from './components/portal/bikeshop/bike-sales/bike-sales.component';
import { InventoryAuditComponent } from './components/portal/bikeshop/inventory-audit/inventory-audit.component';
import { InventorySummaryComponent } from './components/portal/bikeshop/inventory-summary/inventory-summary.component';
import { ServiceImportsComponent } from './components/portal/bikeshop/service-imports/service-imports.component';
import { WidgetSetupComponent } from './components/portal/bikeshop/widget-setup/widget-setup.component';
import { ShopRidesComponent } from './components/portal/bikeshop/shop-rides/shop-rides.component';
import { CreateEditRideComponent } from './components/portal/bikeshop/shop-rides/create-edit-ride/create-edit-ride.component';
import { ShopRidesConfigurationComponent } from './components/portal/bikeshop/shop-rides-configuration/shop-rides-configuration.component';
import { ReferralsComponent } from './components/portal/bikeshop/referrals/referrals.component';
import { ProductRedirectLoaderComponent } from './components/portal/bikeshop/product-redirect-loader/product-redirect-loader.component';
import { ServiceDepositConfigurationComponent } from './components/portal/bikeshop/service-deposit-configuration/service-deposit-configuration.component';
import { RentalsConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-configuration/rentals-configuration.component';
import { RentalsTimeConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-time-configuration/rentals-time-configuration.component';
import { RentalsProductsAccessoriesComponent } from './components/portal/bikeshop/rentals/rentals-products-accessories/rentals-products-accessories.component';
import { RentalsFixedDurationConfigComponent } from './components/portal/bikeshop/rentals/rentals-fixed-duration-config/rentals-fixed-duration-config.component';
import { RentalsFlexibleDurationConfigComponent } from './components/portal/bikeshop/rentals/rentals-flexible-duration-config/rentals-flexible-duration-config.component';
import { ReservationsComponent } from './components/portal/bikeshop/rentals/reservations/reservations.component';
import { RentalsChecklistsComponent } from './components/portal/bikeshop/rentals/rentals-checklists/rentals-checklists.component';
import { RentalsCategoriesComponent } from './components/portal/bikeshop/rentals/rentals-categories/rentals-categories.component';
import { RentalsReservationsSummaryComponent } from './components/portal/bikeshop/rentals/rentals-reservations-summary/rentals-reservations-summary.component';
import { RentalsSettingsComponent } from './components/portal/bikeshop/rentals/rentals-settings/rentals-settings.component';
import { RentalReportsComponent } from './components/portal/bikeshop/rentals/rental-reports/rental-reports.component';
import { RentalCustomWidgetQuestionsComponent } from './components/portal/bikeshop/rentals/rental-custom-widget-questions/rental-custom-widget-questions.component';
import { PaystackIntegrationConfigurationComponent } from './components/portal/bikeshop/paystack-integration-configuration/paystack-integration-configuration.component';
import { RentalAffiliatesComponent } from './components/portal/bikeshop/rentals/rental-affiliates/rental-affiliates.component';
import { RentalAffiliateCommissionReportComponent } from './components/portal/bikeshop/rentals/rental-affiliate-commission-report/rental-affiliate-commission-report.component';
import { RentalsWidgetConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-widget-configuration/rentals-widget-configuration.component';
import { DemosWidgetConfigurationComponent } from './components/portal/bikeshop/rentals/demos-widget-configuration/demos-widget-configuration.component';
import { AddEditServicesComponent } from './components/shared/shared-service/add-edit-services/add-edit-services.component';
import { RentalsSplitPaymentConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-split-payment-configuration/rentals-split-payment-configuration.component';
import { PageNotFoundComponent } from './components/shared/page-not-found/page-not-found.component';
import { CyclistPortalComponent } from './components/portal/cyclist/cyclist-portal/cyclist-portal.component';
import { JobcardMessagingComponent } from './components/portal/cyclist/cyclist-portal/jobcard-messaging/jobcard-messaging.component';
import { JobcardApprovalComponent } from './components/portal/cyclist/cyclist-portal/jobcard-approval/jobcard-approval.component';
import { ServiceDropoffComponent } from './components/portal/cyclist/cyclist-portal/service-dropoff/service-dropoff.component';
import { CyclistPaymentComponent } from './components/portal/cyclist/cyclist-portal/cyclist-payment/cyclist-payment.component';
import { InsuranceQuotesComponent } from './components/portal/cyclist/cyclist-portal/insurance-quotes/insurance-quotes.component';
import { CyclistResetPasswordComponent } from './components/portal/cyclist/cyclist-portal/reset-password/reset-password.component';
import { JobcardAttachmentsPhoneComponent } from './components/portal/cyclist/cyclist-portal/jobcard-attachments-phone/jobcard-attachments-phone.component';
import { JobcardMultiQuoteApprovalComponent } from './components/portal/cyclist/cyclist-portal/jobcard-multi-quote-approval/jobcard-multi-quote-approval.component';
import { SingleManufacturerBikeComponent } from './components/portal/cyclist/cyclist-portal/single-manufacturer-bike/single-manufacturer-bike.component';
import { InsuranceComponent } from './components/portal/insurance/insurance.component';
import { ProcurementComponent } from './components/portal/insurance/procurement/procurement.component';
import { InsuranceDashboardComponent } from './components/portal/insurance/portal/dashboard/dashboard.component';
import { CreateClaimComponent } from './components/portal/insurance/portal/create-claim/create-claim.component';
import { ViewClaimsComponent } from './components/portal/insurance/portal/view-claims/view-claims.component';
import { ViewTasksComponent } from './components/portal/insurance/portal/view-tasks/view-tasks.component';
import { ClaimInfoComponent } from './components/portal/insurance/external-access/claim-info/claim-info.component';
import { AnalyticsDashboardComponent } from './components/portal/superuser/super-user-portal/analytics-dashboard/analytics-dashboard.component';
import { EmbededReportsComponent } from './components/portal/superuser/super-user-portal/embeded-reports/embeded-reports.component';
import { MessagingBundleAdminComponent } from './components/portal/superuser/super-user-portal/messaging-bundle-admin/messaging-bundle-admin.component';
import { CycleShopsComponent } from './components/portal/superuser/super-user-portal/cycle-shops/cycle-shops.component';
import { BikeGearManagementComponent } from './components/portal/superuser/super-user-portal/bike-gear-management/bike-gear-management.component';
import { GearTypeAdvicesComponent } from './components/portal/superuser/super-user-portal/bike-gear-management/gear-type-advices/gear-type-advices.component';
import { GearTypeAdviceComponent } from './components/portal/superuser/super-user-portal/bike-gear-management/gear-type-advices/gear-type-advice/gear-type-advice.component';
import { TrailsManagementComponent } from './components/portal/superuser/super-user-portal/trails-management/trails-management.component';
import { TrailAddEditComponent } from './components/portal/superuser/super-user-portal/trails-management/trail-add-edit/trail-add-edit.component';
import { PushNotificationBroadcastComponent } from './components/portal/superuser/super-user-portal/push-notification-broadcast/push-notification-broadcast.component';
import { AdminTasksComponent } from './components/portal/superuser/super-user-portal/admin-tasks/admin-tasks.component';
import { SyncProgressComponent } from './components/portal/superuser/super-user-portal/sync-progress/sync-progress.component';
import { SuperUserPortalComponent } from './components/portal/superuser/super-user-portal/super-user-portal.component';
import { PrintComponent } from './components/portal/bikeshop/print-job-card-a4/print.component';
import { PrintJobCardTillSlipComponent } from './components/portal/bikeshop/print-job-card-till-slip/print-job-card-till-slip.component';
import { ReservationPrintOutComponent } from './components/portal/bikeshop/rentals/reservations/reservation-print-out/reservation-print-out.component';
import { PrintCollectionsComponent } from './components/portal/bikeshop/print-collections/print-collections.component';
import { RentalsProductsImportComponent } from './components/portal/bikeshop/rentals/rentals-products-import/rentals-products-import.component';
import { WorkshopWaiversComponent } from './components/portal/bikeshop/workshop-waivers/workshop-waivers.component';
import { WorkshopCustomQuestionsComponent } from './components/portal/bikeshop/workshop-custom-questions/workshop-custom-questions.component';
import { RentalsDeliverySummaryComponent } from './components/portal/bikeshop/rentals/rentals-delivery-summary/rentals-delivery-summary.component';
import { RentalsDeliveriesCollectionsConfigurationComponent } from './components/portal/bikeshop/rentals/rentals-deliveries-collections-configuration/rentals-deliveries-collections-configuration.component';
import { WhatsappIntegrationComponent } from './components/portal/bikeshop/whatsapp-integration/whatsapp-integration.component';
import { XeroComponent } from './components/prelogin/xero/xero.component';
import { XerocallbackComponent } from './components/prelogin/xerocallback/xerocallback.component';

import { TextMessagePlatformIntegrationComponent } from './components/portal/bikeshop/text-message-platform-integration/text-message-platform-integration.component';
import { ErrorsComponent } from './components/portal/superuser/super-user-portal/errors/errors.component';
import { ViewComponent as ErrorViewComponent } from './components/portal/superuser/super-user-portal/errors/view/view.component';
import {
  TokenManagementComponent
} from "./components/portal/superuser/super-user-portal/token-managment/token-management.component";
import { RentalsServiceIndicatorsConfigComponent } from './components/portal/bikeshop/rentals/rentals-service-indicators-config/rentals-service-indicators-config.component';
import { RentalsServiceIndicatorStatusReportComponent } from './components/portal/bikeshop/rentals/rentals-service-indicator-status-report/rentals-service-indicator-status-report.component';
import { CallbackTextMessagePlatformComponent } from './components/portal/bikeshop/text-message-platform-integration/callback-text-message-platform/callback-text-message-platform.component';
import { WorkshopServicesKanbanComponent } from './components/portal/bikeshop/workshop-services-kanban/workshop-services-kanban.component';

import { EntraLoginComponent } from './components/prelogin/entra-login/entra-login.component';
import { TrekGigyaLoginComponent } from './components/prelogin/trek-gigya-login/trek-gigya-login.component';

// Receipt Template Designer
import { ReceiptTemplateDesignerComponent } from './components/portal/bikeshop/receipt-template-designer/receipt-template-designer.component';
import { TemplateEditorComponent } from './components/portal/bikeshop/receipt-template-designer/editor/template-editor.component';
import { ReceiptTemplatePrintPageComponent } from './components/portal/bikeshop/receipt-template-designer/print-page/receipt-template-print-page.component';

const storeChildRoutes: Routes = [
  { path: 'configuration-summary', component: QuickLaunchComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'pricing', component: RecordPaymentDetailsComponent },
  { path: 'manage-subscription', component: ManageSubscriptionsComponent },
  { path: 'dashboard/:id', component: DueForServiceDetailComponent },
  { path: 'myprofile', component: MyprofileComponent },
  { path: 'myprofile-tfasetup', component: TFAProfileSetupComponent },
  { path: 'calendar', component: CalendarComponent },
  { path: 'calendar/schedule-service', component: CalendarComponent },
  { path: 'reports', component: ReportsComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'services/:id', component: ServicesComponent },
  { path: 'message-templates', component: MessageTypesComponent },
  {
    path: 'purchase-messaging-bundle',
    component: PurchaseMessagingBundleComponent,
  },
  { path: 'pos-products', component: PosProductsComponent },
  { path: 'import-products', component: ImportProductsComponent },
  //{ path: "service-types", component: ServiceTypesOldComponent },
  { path: 'service-types-edit', component: AddEditServicesComponent },
  { path: 'service-types', component: ServiceTypesComponent },
  { path: 'fittings', component: ServiceTypesComponent },
  //{ path: "service-types-edit", component: EditServiceTypesComponent },
  { path: 'service-types-import', component: ImportServiceTypesComponent },
  { path: 'checklist-items', component: ChecklistItemsComponent },
  {
    path: 'checklist-configuration',
    component: ChecklistConfigurationComponent,
  },
  { path: 'shop-profile', component: ShopProfileComponent },
  { path: 'shop-setup', component: SettingsComponent },
  { path: 'pos-integrations', component: PosIntegrationsComponent },
  {
    path: 'pick-ups-delivery-setup',
    component: CollectionsSetupV2Component,
  },
  { path: 'cyclists', component: CyclistsComponent },
  { path: 'cyclists-import', component: ImportCyclistsComponent },
  { path: 'customers', component: CyclistsComponent },
  { path: 'customers-import', component: ImportCyclistsComponent },
  { path: 'user-management', component: UsersV2Component },
  { path: 'users', component: UsersComponent },
  { path: 'third-party', component: ThirdPartyComponent },
  { path: 'special-orders', component: SpecialOrdersComponent },
  { path: 'collections', component: CollectionsComponent },
  { path: 'community', component: CommunityComponent },
  { path: 'general-communication', component: CommunicationComponent },
  {
    path: 'inapp-payment-configuration',
    component: InAppPaymentConfigurationComponent,
  },
  { path: 'text-message-platform-integration', component: TextMessagePlatformIntegrationComponent },
  { path: 'text-message-platform-integration/callback', component: CallbackTextMessagePlatformComponent },

  { path: 'insurance', component: InsuranceQuoteCreationComponent },
  { path: 'switch-shop', component: SwitchShopComponent },
  { path: 'other-settings', component: OtherSettingsComponent },
  { path: 'online-widget', component: OnlineWidgetComponent },
  { path: 'coupons', component: CouponsComponent },
  { path: 'coupon-detail', component: CouponDetailComponent },
  { path: 'job-card-messages', component: JobCardMessagesComponent },
  { path: 'external-redirect', component: ExternalRedirectComponent },
  { path: 'bike-sales', component: BikeSalesComponent },
  { path: 'inventory-audit', component: InventoryAuditComponent },
  { path: 'inventory-summary', component: InventorySummaryComponent },
  { path: 'service-imports', component: ServiceImportsComponent },
  { path: 'widget-setup', component: WidgetSetupComponent },
  { path: 'shop-rides', component: ShopRidesComponent },
  { path: 'shop-rides/create-shop-ride', component: ShopRidesComponent },
  { path: 'shop-ride', component: CreateEditRideComponent },
  {
    path: 'shop-rides-configuration',
    component: ShopRidesConfigurationComponent,
  },
  { path: 'referrals', component: ReferralsComponent },
  {
    path: 'product-redirect-loader',
    component: ProductRedirectLoaderComponent,
  },
  {
    path: 'service-deposit-configuration',
    component: ServiceDepositConfigurationComponent,
  },
  {
    path: 'custom-questions-config',
    component: WorkshopCustomQuestionsComponent,
  },
  { path: 'waivers-config', component: WorkshopWaiversComponent },
  { path: 'whatsapp-integration', component: WhatsappIntegrationComponent },
  { path: 'paystack-configuration', component: PaystackIntegrationConfigurationComponent },
  { path: 'workshop-services-kanban', component: WorkshopServicesKanbanComponent },
  { path: 'text-message-platform-integration', component: TextMessagePlatformIntegrationComponent },
  { path: 'text-message-platform-integration/callback', component: CallbackTextMessagePlatformComponent },
  {
    path: 'rentals',
    children: [
      { path: 'configuration', component: RentalsConfigurationComponent },
      {
        path: 'time-configuration',
        component: RentalsTimeConfigurationComponent,
      },
      {
        path: 'products-accessories',
        component: RentalsProductsAccessoriesComponent,
      },
      {
        path: 'products-import',
        component: RentalsProductsImportComponent,
      },
      { path: 'billing', component: RentalsFixedDurationConfigComponent },
      {
        path: 'fixed-duration-rental-config',
        component: RentalsFixedDurationConfigComponent,
      },
      {
        path: 'flexible-duration-rental-config',
        component: RentalsFlexibleDurationConfigComponent,
      },
      { path: 'reservations', component: ReservationsComponent },

      { path: 'checklists', component: RentalsChecklistsComponent },
      { path: 'categories', component: RentalsCategoriesComponent },
      {
        path: 'reservations-summary',
        component: RentalsReservationsSummaryComponent,
      },
      {
        path: 'reservations-summary/create-reservation',
        component: RentalsReservationsSummaryComponent,
      },
      {
        path: 'reservations-tour',
        component: RentalsReservationsSummaryComponent,
      },
      {
        path: 'reservations-summary-tour',
        component: RentalsReservationsSummaryComponent,
      },
      { path: 'settings', component: RentalsSettingsComponent },
      { path: 'message-templates', component: MessageTypesComponent },
      { path: 'user-management', component: UsersV2Component },
      { path: 'job-card-messages', component: JobCardMessagesComponent },
      // { path: "dashboard", component: DashboardComponent },
      { path: 'customers', component: CyclistsComponent },
      { path: 'customers-import', component: ImportCyclistsComponent },
      { path: 'cyclists', component: CyclistsComponent },
      { path: 'cyclists-import', component: ImportCyclistsComponent },
      { path: 'pos-integrations', component: PosIntegrationsComponent },
      {
        path: 'purchase-messaging-bundle',
        component: PurchaseMessagingBundleComponent,
      },
      { path: 'pricing', component: RecordPaymentDetailsComponent },
      {
        path: 'manage-subscription',
        component: ManageSubscriptionsComponent,
      },
      { path: 'shop-profile', component: ShopProfileComponent },
      { path: 'pos-products', component: PosProductsComponent },
      {
        path: 'inapp-payment-configuration',
        component: InAppPaymentConfigurationComponent,
      },
      { path: 'switch-shop', component: SwitchShopComponent },
      { path: 'reports', component: RentalReportsComponent },
      {
        path: 'custom-widget-questions',
        component: RentalCustomWidgetQuestionsComponent,
      },
      {
        path: 'paystack-configuration',
        component: PaystackIntegrationConfigurationComponent,
      },
      {
        path: 'long-term-payments-config',
        component: RentalsSplitPaymentConfigurationComponent,
      },
      {
        path: 'affiliates-configuration',
        component: RentalAffiliatesComponent,
      },
      {
        path: 'affiliate-commission-payments',
        component: RentalAffiliateCommissionReportComponent,
      },
      {
        path: 'coupons',
        component: CouponsComponent,
      },
      {
        path: 'coupon-detail',
        component: CouponDetailComponent,
      },
      {
        path: 'deliveries-and-collections',
        component: RentalsDeliveriesCollectionsConfigurationComponent,
      },
      {
        path: 'deliveries',
        component: RentalsDeliverySummaryComponent,
      },
      {
        path: 'whatsapp-integration',
        component: WhatsappIntegrationComponent,
      },
      {
        path: 'service-indicators-configuration',
        component: RentalsServiceIndicatorsConfigComponent,
      },
      {
        path: 'service-indicator-dashboard',
        component: RentalsServiceIndicatorStatusReportComponent,
      }
    ],
  },
  {
    path: 'rentals-widget-configuration',
    component: RentalsWidgetConfigurationComponent,
  },
  {
    path: 'demos-widget-configuration',
    component: DemosWidgetConfigurationComponent,
  },
  // Receipt Template Designer
  {
    path: 'receipt-templates',
    children: [
      { path: '',                                  component: ReceiptTemplateDesignerComponent  },
      { path: 'new',                               component: TemplateEditorComponent           },
      { path: 'editor/:id',                        component: TemplateEditorComponent           },
      { path: 'print/:templateId/:jobCardId',      component: ReceiptTemplatePrintPageComponent },
    ],
  },
  { path: '**', component: PageNotFoundComponent },
];

const customerChildernRoutes: Routes = [
  {
    path: 'jobcard-messaging/:athleteid/:partnerid/:jobcardid',
    component: JobcardMessagingComponent,
  },
  {
    path: 'jobcard-approval/:serviceid',
    component: JobcardApprovalComponent,
  },
  {
    path: 'jobcard-dropOff/:serviceid',
    component: ServiceDropoffComponent,
  },
  {
    path: 'payment/:serviceid',
    component: CyclistPaymentComponent,
  },
  {
    path: 'insurance-quote/:quoteid',
    component: InsuranceQuotesComponent,
  },
  {
    path: 'reset-password/:clientID',
    component: CyclistResetPasswordComponent,
  },
  {
    path: 'jobcardAttachments/:jobCardID',
    component: JobcardAttachmentsPhoneComponent,
  },
  {
    path: 'quote-options/:serviceIdentifier',
    component: JobcardMultiQuoteApprovalComponent,
  },
  {
    path: 'manufacturer-bike/:sku/:showNewBikeSaleBanner',
    component: SingleManufacturerBikeComponent,
  },
];

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      { path: '', component: LoginComponent },
      { path: 'forgotpassword', component: ForgotpasswordComponent },
      { path: 'insurance', component: InsuranceloginComponent },
      { path: 'xero/signup', component: XeroComponent },
      { path: 'xero/callback', component: XerocallbackComponent },
    ],
  },
  
  { path: 'auth', component: HomeComponent,
    children:[
      { path: 'callback/ascend', component: TrekGigyaLoginComponent}
    ]
   },
  { path: 'entra/auth', component: EntraLoginComponent },
  //{ path: 'bikeshop-wizard', component: BikeshopWizardComponent },
  { path: 'bikeshop-wizard', redirectTo: 'signup-wizard', pathMatch: 'prefix' },
  { path: 'signup-wizard', component: BikeshopWizardComponent },
  { path: 'pos/callback/xero', component: CallbackXeroComponent },
  { path: 'pos/callback/light-speed', component: CallbackLightspeedComponent },
  { path: 'pos/callback/vend', component: CallbackVendComponent },
  { path: 'pos/callback/shopify', component: CallbackShopifyComponent },
  { path: 'pos/callback/square', component: CallbackSquareComponent },
  { path: 'pos/callback/heartland', component: HeartlandsCallbackComponent },
  {
    path: 'stripe-connect/callback',
    component: StripeConnectCallbackComponent,
  },
  { path: '2facode', component: TFACodeComponent },
  { path: '2fasetup', component: TFASetupComponent },
  { path: 'text-message-platform-integration', component: TextMessagePlatformIntegrationComponent },
  { path: 'text-message-platform-integration/callback', component: CallbackTextMessagePlatformComponent },

  // {
  //   path: 'bikeshop',
  //   component: PortalComponent,
  //   children: storeChildRoutes
  // },
  { path: 'bikeshop', redirectTo: 'store', pathMatch: 'prefix' },

  {
    path: 'store',
    component: PortalComponent,
    children: storeChildRoutes
  },

  // {
  //   path: 'cyclist',
  //   component: CyclistPortalComponent,
  //   children: customerChildernRoutes
  // },
  {
    path: 'customer',
    component: CyclistPortalComponent,
    children: customerChildernRoutes
  },
  { path: 'cyclist', redirectTo: 'customer', pathMatch: 'prefix' },
  {
    path: 'insurance',
    component: InsuranceComponent,
    children: [
      { path: 'procurement', component: ProcurementComponent },
      { path: 'dashboard', component: InsuranceDashboardComponent },
      { path: 'claim', component: CreateClaimComponent },
      { path: 'claims', component: ViewClaimsComponent },
      { path: 'tasks', component: ViewTasksComponent },
      { path: 'client-claim/:claimid', component: ClaimInfoComponent },
    ],
  },
  {
    path: 'client-claim/:claimid',
    component: ClaimInfoComponent,
  },
  {
    path: 'administration',
    component: SuperUserPortalComponent,
    children: [
      { path: 'myprofile', component: MyprofileComponent },
      { path: 'myprofile-tfasetup', component: TFAProfileSetupComponent },
      { path: 'analytics', component: AnalyticsDashboardComponent },
      { path: 'reports', component: EmbededReportsComponent },
      { path: 'messaging-bundles', component: MessagingBundleAdminComponent },
      { path: 'cycle-shops', component: CycleShopsComponent },
      { path: 'stores', component: CycleShopsComponent },
      { path: 'errors', component: ErrorsComponent },
      { path: 'error/:id', component: ErrorViewComponent },
      { path: 'customers', component: CyclistsComponent },
      { path: 'cyclists', component: CyclistsComponent },
      { path: 'cyclists-import', component: ImportCyclistsComponent },
      { path: 'customers-import', component: ImportCyclistsComponent },
      { path: 'bike-gear-management', component: BikeGearManagementComponent },
      { path: 'bike-gear-advices', component: GearTypeAdvicesComponent },
      { path: 'bike-gear-advice/create', component: GearTypeAdviceComponent },
      {
        path: 'bike-gear-advice/:biketype/:geartype/:languagecode',
        component: GearTypeAdviceComponent,
      },
      { path: 'bike-gear-advice/:id', component: GearTypeAdviceComponent },
      { path: 'trails-management', component: TrailsManagementComponent },
      {
        path: 'trails-management/trails/create',
        component: TrailAddEditComponent,
      },
      {
        path: 'trails-management/trails/:id',
        component: TrailAddEditComponent,
      },
      {
        path: 'push-notification-broadcast',
        component: PushNotificationBroadcastComponent,
      },
      {
        path: 'token-management',
        component: TokenManagementComponent,
      },
      { path: 'admin-tasks', component: AdminTasksComponent },
      { path: 'sync-progress', component: SyncProgressComponent },
      { path: '**', component: PageNotFoundComponent },

    ],
  },
  {
    path: 'print/:id',
    component: PrintComponent,
  },
  {
    path: 'print-till-slip/:id',
    component: PrintJobCardTillSlipComponent,
  },
  {
    path: 'rentals/print-out/:reservationIdentifier',
    component: ReservationPrintOutComponent,
  },
  { path: 'print-deliveries', component: PrintCollectionsComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
